import ContentLoader from "react-content-loader";
import React from "react";

export const Sidebar = () => {
  return (
    <ContentLoader
      speed={2}
      width={500}
      height={700}
      viewBox="0 0 500 700"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="27" y="131" rx="3" ry="3" width="25" height="18" />
      <rect x="85" y="133" rx="0" ry="0" width="118" height="11" />
      <rect x="335" y="133" rx="0" ry="0" width="81" height="11" />
      <circle cx="447" cy="138" r="12" />
      <rect x="30" y="194" rx="3" ry="3" width="25" height="18" />
      <rect x="88" y="196" rx="0" ry="0" width="118" height="11" />
      <rect x="338" y="196" rx="0" ry="0" width="81" height="11" />
      <circle cx="450" cy="201" r="12" />
      <rect x="30" y="248" rx="3" ry="3" width="25" height="18" />
      <rect x="88" y="250" rx="0" ry="0" width="118" height="11" />
      <rect x="338" y="250" rx="0" ry="0" width="81" height="11" />
      <circle cx="450" cy="255" r="12" />
      <rect x="31" y="307" rx="3" ry="3" width="25" height="18" />
      <rect x="89" y="309" rx="0" ry="0" width="118" height="11" />
      <rect x="339" y="309" rx="0" ry="0" width="81" height="11" />
      <circle cx="451" cy="314" r="12" />
      <rect x="33" y="75" rx="3" ry="3" width="25" height="6" />
      <rect x="88" y="71" rx="0" ry="0" width="118" height="14" />
      <rect x="6" y="49" rx="2" ry="2" width="487" height="1" />
      <rect x="9" y="107" rx="2" ry="2" width="487" height="1" />
      <rect x="8" y="165" rx="2" ry="2" width="487" height="1" />
      <rect x="6" y="225" rx="2" ry="2" width="487" height="1" />
      <rect x="7" y="285" rx="2" ry="2" width="487" height="1" />
      <rect x="6" y="343" rx="2" ry="2" width="487" height="1" />
      <rect x="30" y="361" rx="3" ry="3" width="25" height="18" />
      <rect x="88" y="363" rx="0" ry="0" width="118" height="11" />
      <rect x="338" y="363" rx="0" ry="0" width="81" height="11" />
      <circle cx="450" cy="368" r="12" />
      <rect x="31" y="420" rx="3" ry="3" width="25" height="18" />
      <rect x="89" y="422" rx="0" ry="0" width="118" height="11" />
      <rect x="339" y="422" rx="0" ry="0" width="81" height="11" />
      <circle cx="451" cy="427" r="12" />
      <rect x="7" y="398" rx="2" ry="2" width="487" height="1" />
      <rect x="6" y="456" rx="2" ry="2" width="487" height="1" />
      <rect x="491" y="49" rx="0" ry="0" width="2" height="408" />
      <rect x="4" y="50" rx="0" ry="0" width="2" height="408" />
      <rect x="31" y="503" rx="3" ry="3" width="25" height="6" />A
      <rect x="86" y="499" rx="0" ry="0" width="118" height="14" />
      <rect x="4" y="477" rx="2" ry="2" width="487" height="1" />
      <rect x="22" y="534" rx="2" ry="2" width="487" height="1" />
      <rect x="5" y="477" rx="0" ry="0" width="2" height="58" />
      <rect x="491" y="478" rx="0" ry="0" width="2" height="58" />
      <rect x="41" y="494" rx="4" ry="4" width="5" height="22" />
    </ContentLoader>
  );
};
